// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"TL-z","upvoteIcon":"UL-z","downvoteIcon":"VL-z","feedbackIcon":"WL-z"};